// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TWebCreateFolderRequest, TWebCreateFolderModel, IMappers, TWebCreateFolderResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IFolderResponseSchema } from '../../../entities/user_folder/FolderResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebCreateFolderModel(parameters: TWebCreateFolderRequest): TWebCreateFolderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/web/create-folder/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebCreateFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebCreateFolderRequest;
}

export async function fetchWebCreateFolder<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebCreateFolderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebCreateFolderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebCreateFolderModel(parameters),
    config,
  )) as FetchResponse<TWebCreateFolderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IFolderResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebCreateFolderResponse>;
}
